import React from 'react';
import { motion } from 'framer-motion';
import { Check, ShieldCheck, ArrowRight } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function PurchaseSection() {
  const handleBuyClick = () => {
    // Track AddToCart event
    trackAddToCart();
    // Redirect to Shopify cart
    window.location.href = 'https://onlinepack-5.myshopify.com/cart/44608060981302:1';
  };
  return <section id="purchase-section" className="py-24 bg-[#FFF8F0] px-4 sm:px-6 lg:px-8" data-id="element-129">
      <div className="max-w-5xl mx-auto" data-id="element-130">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl shadow-xl overflow-hidden border border-[#D4A5A5]/30" data-id="element-131">
          <div className="grid md:grid-cols-2" data-id="element-132">
            {/* Image Side */}
            <div className="bg-[#F9F4EF] p-8 flex flex-col items-center justify-center relative" data-id="element-133">
              <div className="relative w-full max-w-sm mx-auto" data-id="element-134">
                <img src="https://cdn.magicpatterns.com/uploads/v5AwTcLwZ2PDUfLZGbjrn1/ChatGPT_Image_20_dic_2025,_05_20_25_p.m..png" alt="El Manual Secreto de la Abuela 2.0" className="w-full h-auto rounded-lg shadow-lg transform rotate-[-2deg] hover:rotate-0 transition-transform duration-500" data-id="element-135" />
                <div className="absolute -bottom-10 -right-4 w-2/3" data-id="element-136"></div>
              </div>
            </div>

            {/* Content Side */}
            <div className="p-8 md:p-12 flex flex-col justify-center" data-id="element-137">
              <div className="mb-2 inline-block bg-[#D4A5A5]/10 text-[#D4A5A5] px-3 py-1 rounded-full text-xs font-bold tracking-wider uppercase" data-id="element-138">
                Oferta Limitada
              </div>
              <h2 className="text-3xl font-serif font-bold text-[#5C4033] mb-4" data-id="element-139">
                El Manual Secreto de la Abuela 2.0
              </h2>

              <div className="space-y-4 mb-8" data-id="element-140">
                <div className="flex items-center gap-3" data-id="element-141">
                  <Check className="text-[#9CAF88] w-5 h-5 flex-shrink-0" data-id="element-142" />
                  <span className="text-[#6B5A4D]" data-id="element-143">
                    Manual completo (Formato digital)
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-144">
                  <Check className="text-[#9CAF88] w-5 h-5 flex-shrink-0" data-id="element-145" />
                  <span className="text-[#6B5A4D]" data-id="element-146">
                    Acceso de por vida + Actualizaciones
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-147">
                  <Check className="text-[#9CAF88] w-5 h-5 flex-shrink-0" data-id="element-148" />
                  <span className="text-[#6B5A4D] font-medium" data-id="element-149">
                    Bono: "El Botiquín Invisible de la Abuela"
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-150">
                  <Check className="text-[#9CAF88] w-5 h-5 flex-shrink-0" data-id="element-151" />
                  <span className="text-[#6B5A4D]" data-id="element-152">
                    Guía rápida "10 remedios de emergencia"
                  </span>
                </div>
              </div>

              <div className="flex items-end gap-4 mb-8" data-id="element-153">
                <div className="text-5xl font-serif font-bold text-[#5C4033]" data-id="element-154">
                  $14.990
                </div>
                <div className="text-[#8B7355] line-through mb-2 text-lg opacity-60" data-id="element-155">
                  $49.990
                </div>
              </div>

              <button onClick={handleBuyClick} className="w-full bg-[#9CAF88] hover:bg-[#8A9F76] text-white py-4 rounded-xl text-lg font-bold shadow-lg hover:shadow-xl transition-all flex items-center justify-center gap-2 group" data-id="element-156">
                Acceder ahora al Manual
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-157" />
              </button>

              <div className="mt-6 flex items-start gap-3 p-4 bg-[#F9F4EF] rounded-lg border border-[#D4A5A5]/20" data-id="element-158">
                <ShieldCheck className="text-[#D4A5A5] w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-159" />
                <div data-id="element-160">
                  <p className="font-bold text-[#5C4033] text-sm" data-id="element-161">
                    Garantía de 30 días
                  </p>
                  <p className="text-[#8B7355] text-xs mt-1" data-id="element-162">
                    Probalo sin riesgo. Si no es para vos, te devolvemos el
                    dinero sin preguntas.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}